export const en = {
  DOSCOVER: 'Discover the',
  PLANET: 'planet',
  WITH: 'with',
  TRAVEL_APP: 'Travel-app',
  BACK: 'Back',
  COUNTRY_OVERVIEW: 'Country overview',
  ON_THE_MAP: 'On the map',
  COUNTRY: 'Country',
  CAPITAL: 'Capital',
  SEARCH: 'Search',
  CURRENT_CURRENCY: 'Local currency',
  IS: 'is',
  COSTS: 'costs',
  LOCAL_TIME: 'The local time',
  TODAY: "Today",
  FEELS: "Feels like",
  WIND_SPEED: "Wind speed is",
  WIND_SPEED_UNIT: "m/s",
  AIR_HUMINDITY: "Air humidity",
  COUNTRY_ATTRACTION: 'Country attractions',
  NAME: 'Name',
  INVALID_NAME: 'Name is not valid.',
  EMAIL: 'Email',
  INVALID_EMAIL: 'Email is not valid.',
  PASSWORD: 'Password',
  INVALID_PASSWORD: 'Password is not valid.',
  UPLOAD_PHOTO: 'Upload photo',
  UPLOADED_PHOTO: 'Photo uploaded',
  SIGNIN: 'Sign In',
  SIGNUP: 'Sign Up',
  ACCOUNT: 'Account',
  LOGGED_AS: 'You have been logged as',
  LOGOUT: 'Log out',
};

export const ru = {
  DOSCOVER: 'Откройте для себя',
  PLANET: 'планету',
  WITH: 'вместе с',
  TRAVEL_APP: 'Travel-app',
  BACK: 'Назад',
  COUNTRY_OVERVIEW: 'Обзор достопримечательностей',
  ON_THE_MAP: 'На карте',
  COUNTRY: 'Страна',
  CAPITAL: 'Столица',
  SEARCH: 'Поиск',
  CURRENT_CURRENCY: 'Местная валюта',
  IS: 'это',
  COSTS: 'стоит',
  LOCAL_TIME: 'Местное время',
  TODAY: "Сегодня",
  FEELS: "Чувствуется как",
  WIND_SPEED: "Скорость ветра",
  WIND_SPEED_UNIT: "м/с",
  AIR_HUMINDITY: "Влажность воздуха",
  COUNTRY_ATTRACTION: 'Достопримечательности страны',
  NAME: 'Имя/ник',
  INVALID_NAME: 'Имя/ник введены в неверном формате.',
  EMAIL: 'Email',
  INVALID_EMAIL: 'Email введен в неверном формате.',
  PASSWORD: 'Пароль',
  INVALID_PASSWORD: 'Пароль введен в неверном формате.',
  UPLOAD_PHOTO: 'Загрузить фото',
  UPLOADED_PHOTO: 'Фото загружено',
  SIGNIN: 'Вход',
  SIGNUP: 'Регистрация',
  ACCOUNT: 'Аккаунт',
  LOGGED_AS: 'Вы вошли как',
  LOGOUT: 'Выйти',
};

export const ua = {
  DOSCOVER: 'Відкрийте для себе',
  PLANET: 'планету',
  WITH: 'разом з',
  TRAVEL_APP: 'Travel-app',
  BACK: 'Назад',
  COUNTRY_OVERVIEW: "Огляд визначних пам'яток",
  ON_THE_MAP: 'На карті',
  COUNTRY: 'Країна',
  CAPITAL: 'Столиця',
  SEARCH: 'Пошук',
  CURRENT_CURRENCY: 'Місцева валюта',
  IS: 'це',
  COSTS: 'коштує',
  LOCAL_TIME: 'Місцевий час',
  TODAY: "Сьогодні",
  FEELS: "Відчувається як",
  WIND_SPEED: "Швидкість вітру",
  WIND_SPEED_UNIT: "м/с",
  AIR_HUMINDITY: "Вологість повітря",
  COUNTRY_ATTRACTION: 'Визначні місця країни',
  NAME: "Ім'я",
  INVALID_NAME: "Ім'я не дійсне.",
  EMAIL: 'Email',
  INVALID_EMAIL: "Електронна адреса недійсна.",
  PASSWORD: 'Пароль',
  INVALID_PASSWORD: 'Пароль не дійсний.',
  UPLOAD_PHOTO: 'Завантажити фото',
  UPLOADED_PHOTO: 'Фото завантажено',
  SIGNIN: 'Увійти',
  SIGNUP: 'Реєстрація',
  ACCOUNT: 'Аккаунт',
  LOGGED_AS: 'Ви зареєстровані як',
  LOGOUT: 'Вийти',
};